import { Cloud, Tag, Shield } from "lucide-react";
import {useNavigate} from "react-router-dom"

export default function Index() {

  let navigate = useNavigate();

  const styles = {
    landingPage: {
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      lineHeight: '1.6',
      color: '#1a1a1a',
      background: 'linear-gradient(135deg, #fef3c7 0%, #fcd34d 100%)',
      height: '100vh',
      margin: 0,
      padding: 0,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      position: 'relative',
      overflow: 'hidden',
    },
    container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
      position: 'relative',
      zIndex: 10,
    },
    header: {
      padding: '20px 0',
    },
    headerNav: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    logo: {
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      fontSize: '28px',
      fontWeight: 700,
      color: '#d97706',
    },
    logoIcon: {
      width: '36px',
      height: '36px',
      color:'#d97706'
    },
    signupButton: {
      background: 'rgba(255, 255, 255, 0.2)',
      color: '#d97706',
      border: '1px solid rgba(255, 255, 255, 0.3)',
      padding: '10px 20px',
      borderRadius: '25px',
      fontWeight: 600,
      fontSize: '14px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      marginRight:"10px"
    },
    main: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center',
      padding: '0 20px',
      position: 'relative',
    },
    heroTitle: {
      fontSize: '4rem',
      fontWeight: 700,
      color: 'white',
      marginBottom: '30px',
      lineHeight: '1.1',
      maxWidth: '800px',
    },
    heroSubtitle: {
      fontSize: '1.2rem',
      color: 'rgba(255, 255, 255, 0.9)',
      marginBottom: '40px',
      maxWidth: '600px',
      margin: '0 auto 40px'
    },
    ctaButton: {
      background: 'white',
      color: '#d97706',
      border: 'none',
      padding: '16px 32px',
      borderRadius: '50px',
      fontWeight: 600,
      fontSize: '16px',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
      marginBottom: '60px',
    },
    statsContainer: {
      display: 'flex',
      gap: '100px',
      alignItems: 'center',
      justifyContent: 'center',
    },
    stat: {
      textAlign: 'center',
      color: 'white',
    },
    statNumber: {
      fontSize: '2.5rem',
      fontWeight: 800,
      display: 'block',
      marginBottom: '5px',
    },
    statLabel: {
      fontSize: '1rem',
      opacity: 0.9,
    },
    noteCard: {
      position: 'absolute',
      background: 'white',
      borderRadius: '12px',
      padding: '20px',
      boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
      width: '250px',
      zIndex: 5,
    },
    noteCard1: {
      top: '25%',
      right: '10%',
      transform: 'rotate(5deg)',
    },
    noteCard2: {
      bottom: '25%',
      left: '8%',
      transform: 'rotate(-3deg)',
    },
    noteHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '15px',
    },
    noteTitle: {
      fontWeight: 600,
      fontSize: '16px',
      color: '#1a1a1a',
    },
    noteIcon: {
      width: '16px',
      height: '16px',
      color: '#d97706',
    },
    noteContent: {
      marginBottom: '15px',
    },
    noteLine: {
      height: '6px',
      background: '#f3f4f6',
      borderRadius: '3px',
      marginBottom: '6px',
    },
    noteLineShort: {
      width: '70%',
    },
    noteTags: {
      display: 'flex',
      gap: '8px',
    },
    tag: {
      background: '#d97706',
      color: 'white',
      padding: '4px 12px',
      borderRadius: '12px',
      fontSize: '11px',
      fontWeight: 500,
    },
    footer: {
      textAlign: 'center',
      padding: '20px 0',
      color: 'rgba(255, 255, 255, 0.8)',
      fontSize: '0.9rem',
    },
  };

  return (
    <div style={styles.landingPage}>
      <style>
        {`
          .cta-button:hover {
            transform: translateY(-2px);
            box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
          }

          .signup-button:hover {
            background: rgba(255, 255, 255, 0.3);
            transform: translateY(-1px);
          }
          
          @keyframes float {
            0%, 100% { transform: translateY(0px) rotate(5deg); }
            50% { transform: translateY(-10px) rotate(5deg); }
          }
          
          @keyframes floatReverse {
            0%, 100% { transform: translateY(0px) rotate(-3deg); }
            50% { transform: translateY(10px) rotate(-3deg); }
          }
          
          .note-card-1 {
            animation: float 6s ease-in-out infinite;
          }
          
          .note-card-2 {
            animation: floatReverse 6s ease-in-out infinite 3s;
          }
          
          @media (max-width: 768px) {
            .hero-title {
              font-size: 2.5rem !important;
            }
            
            .hero-subtitle {
              font-size: 1rem !important;
            }
            
            .stats-container {
              gap: 40px !important;
            }
            
            .note-card {
              display: none !important;
            }
          }
          
          @media (max-width: 480px) {
            .hero-title {
              font-size: 2rem !important;
            }
            
            .cta-button {
              width: 100%;
              max-width: 300px;
            }
          }
        `}
      </style>

      {/* Header */}
      <header style={styles.header}>
        <div style={styles.container}>
          <div style={styles.headerNav}>
            <div style={styles.logo}>
              <Cloud style={styles.logoIcon} />
              <span>MinDrop</span>
            </div>
            <div>
            <button onClick={()=>navigate("/about")}style={styles.signupButton} className="signup-button">
              About
            </button>
            <button onClick={()=>navigate("/signup")}style={styles.signupButton} className="signup-button">
              Signup
            </button>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main style={styles.main}>
        <div style={styles.container}>
          <h1 style={styles.heroTitle} className="hero-title">
            Your thoughts, securely stored in the cloud
          </h1>
          <p style={styles.heroSubtitle} className="hero-subtitle">
            MinDrop is the modern note-taking app that keeps your ideas safe and ensures only you can access them.
          </p>
          <button onClick={()=>navigate("/signup")}style={styles.ctaButton} className="cta-button">
            Start Taking Notes →
          </button>
          
          <div style={styles.statsContainer} className="stats-container">
            <div style={styles.stat}>
              <span style={styles.statNumber}>100%</span>
              <span style={styles.statLabel}>Secure</span>
            </div>
            <div style={styles.stat}>
              <span style={styles.statNumber}>24/7</span>
              <span style={styles.statLabel}>Sync</span>
            </div>
          </div>
        </div>

        {/* Floating Note Cards */}
        <div style={{...styles.noteCard, ...styles.noteCard1}} className="note-card note-card-1">
          <div style={styles.noteHeader}>
            <div style={styles.noteTitle}>Meeting Notes</div>
            <Tag style={styles.noteIcon} />
          </div>
          <div style={styles.noteContent}>
            <div style={styles.noteLine}></div>
            <div style={{...styles.noteLine, ...styles.noteLineShort}}></div>
            <div style={styles.noteLine}></div>
          </div>
          <div style={styles.noteTags}>
            <span style={styles.tag}>work</span>
            <span style={styles.tag}>important</span>
          </div>
        </div>

        <div style={{...styles.noteCard, ...styles.noteCard2}} className="note-card note-card-2">
          <div style={styles.noteHeader}>
            <div style={styles.noteTitle}>Ideas</div>
            <Shield style={styles.noteIcon} />
          </div>
          <div style={styles.noteContent}>
            <div style={styles.noteLine}></div>
            <div style={styles.noteLine}></div>
            <div style={{...styles.noteLine, ...styles.noteLineShort}}></div>
          </div>
          <div style={styles.noteTags}>
            <span style={styles.tag}>creative</span>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.container}>
          <p>MinDrop - Built for your thoughts</p>
        </div>
      </footer>
    </div>
  );
}
 